import React, { useEffect, useState } from 'react'
import { BackButton, CancelButton, SubmitButton } from '../../../../Components/Utils/Buttons';
import FormikSelectTwo from '../../../../Components/Utils/Select';
import { NuDate, NuInput, NuTextArea } from '../../../../Components/Utils/Input';
import { useFormik } from 'formik';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import * as yup from 'yup';
import useEditFormData from '../../../../Components/Hooks/useEditFormData';
import Breadcrumb from '../../../../Components/Utils/Breadcrumb';
import useFetchMataData from '../../../../Components/Hooks/useFetchMataData';
import UseCustomerDropDownNew from '../../../../Components/Hooks/useCustomerSearch';
import UseDropDown from '../../../../Components/Hooks/useDropDown';
import DropDownAddMetaData from '../../../../Components/Utils/selectAddMetaData';
import Attachement, { videotype } from '../../../../Components/Utils/CustomAttrachmentupload';
import Video from '../../../../Components/Icons/Video';
import Doc from '../../../../Components/Icons/Doc';
import Xls from '../../../../Components/Icons/Xls';
import Txt from '../../../../Components/Icons/Txt';
import Pdf from '../../../../Components/Icons/Pdf';
import CloseIcon from '../../../../Components/Icons/Close';
import { useToast } from '../../../../Components/Others/ToastServices';
import axiosInstance from '../../../../Services/axiosCommon';
import { GetNotUseRole } from '../../../../Components/Utils/roles';
import { SettingHeading } from '../../../../Components/Utils/Settingheading';
const filetype = [
  "docx",
  "doc",
  "xlsx",
  "xls",
  "pdf",
  "txt",
  "pptx",
  "mp4",
  "mov",
  "wmv",
  "avi",
  "flv",
  "mkv",
];

function EditClientTickets() {
  const { clientTickEditId } = useParams();
  const navigate = useNavigate();
                const toast = useToast();

  const [image, setImage] = useState([]);
      
          const [selectedFile, setSelectedFile] = useState(null);
           const [filePathList, setFilePathList] = useState([]);
           const [fileRemoveList, setFileRemoveList] = useState([]);
                  const [removefilePathList, setRemoveFilePathList] = useState([]);
                  const [selectedImage, setSelectedImage] = useState(null);
                    const [fileExtention, setFileExtention] = useState("");
                                                const [isModalOpen, setIsModalOpen] = useState(false);
  const location = useLocation();
  const data = location.state?.data;

  
const from = location.state?.from;

const [searchClient, setSearchClient] = useState("");
  
const { data: client, setDataCustomer } = UseCustomerDropDownNew(
  "/clients/drop-down",
  searchClient
);


const { value: TicketType,getData:refTicketType } = useFetchMataData(
  `/dropdown/dropdown-details/`,
  "Ticket_Type"
);  

const { value: Priority,getData:refPriority } = useFetchMataData(
  `/dropdown/dropdown-details/`,
  "priority"
);  

const { value: Status,getData:refStatus } = useFetchMataData(
  `/dropdown/dropdown-details/`,
  "Status_Support_Tickets"
); 
const [createNew, setCreateNew] = useState([]);
const {  editFormData,isLoading } =useEditFormData(); 
  function getView() {
    axiosInstance
      .get(`/tickets/ticket-details/${clientTickEditId}`)
      .then((res) => {
        console.log(res,'response');
    setCreateNew({
  
    contractId: res?.data?.data?.contractId
    || "",
    subject: res?.data?.data?.subject  || "",
    message: res?.data?.data?.message  || "",
    clientId: res?.data?.data?.clientId  || "",
    ticketType: res?.data?.data?.ticketType  || "",
    priority:res?.data?.data?.priority || "",
  status: res?.data?.data?.status || "",
  refNumber: res?.data?.data?.refNumber || "",
   filesToRemove:[]


  
});
})
.catch((err) => {
  console.log("err", err);
});
}
 useEffect(() => {
    // if (!cData) {
    getView();
    console.log(createNew,"createnew");
    
    // }
  }, []);
const formik = useFormik({
  enableReinitialize: true,
  initialValues: createNew,
  validateOnChange: false,
  validateOnBlur: false,
  validationSchema: yup.object({
    // clientId: yup.string().required("Client is required!"),
          contractId: yup.string().required("Contract is required!"),
        }),
  onSubmit: async (value, { resetForm }) => {
    let formData = new FormData();
    const valueWithProducts = {
      ...value,
      // products: productsString,
      // services: servicesString,
      // emails: emailsString,
    filesToRemove: fileRemoveList,

     
    };
    formData.append("json_data", JSON.stringify(valueWithProducts));
    // formData.append("attachments", image.raw);
    if (selectedFile !== null) {
      selectedFile.forEach((file) => {
        formData.append("attachments", file);
      });
    } else {
      formData.append("attachments", []);
    }
                     await editFormData({url:`/tickets/edit-ticket/${clientTickEditId}`,formData:formData,navigateUrl:from ||`/tickets/client-tickets`,resetForm:resetForm   })

    // editFormData(
    //   `/tickets/edit-ticket/${clientTickEditId}`,
    //   formData,
    //   resetForm,
    //   from,
    // );
  },
});


 function handleImageChange(e) {
    const maxFileSize = 200000000; // 200 MB
    const files = Array.from(e.target.files);
    let fileArr = [];

    files.forEach((item) => {
      if (item.size < maxFileSize) {  
        fileArr.push(item);
      } else {
        toast.open({
          type: "warning",
          message: `File Size too big`,
          description: `${item.name} is removed and not uploaded`,
        });
      }
    });

    setSelectedFile(fileArr);


    setImage(fileArr);
    e.target.value = null;
  }

  const removeImages = (value) => {
    let List = selectedFile.filter((item) => item?.name !== value?.name);
    setSelectedFile([...List]);
    setImage(List);
  };
       
         useEffect(() => {
           if (
             data?.attachments !== null &&
             data?.attachments !== "None" &&
             data?.attachments !== "[]"
           ) {
             console.log(data?.attachments, "ghjkllgd");
             setFilePathList(data?.attachments);
       
             setRemoveFilePathList(data?.attachments);
           }
         }, [data]);
       
         function UpdateAttachmentList(item) {
           let filterList = filePathList.filter((itemList) => itemList.file !== item);
           let removeFile = filePathList.find((itemList) => itemList.file === item);
           console.log("llll", filterList);
           setFileRemoveList([...fileRemoveList, removeFile.file]);
           setFilePathList(filterList);
         }
       
         function handleImageClick(img) {
           let Ext = img?.file_name.split(".").reverse()[0];
           setSelectedImage(img);
           setFileExtention(Ext);
           setIsModalOpen(true);
         }

 const [Newcontract, setContract] = useState([]);

function getViewcontract(clientId) {
  axiosInstance
    .get(`/contract/drop-down/client/${clientId}`)
    .then((res) => {
      const formattedContracts = res.data?.map(item => ({
        value: item.id,
        label: item.name,
      })) || [];
      setContract(formattedContracts);
    })
    .catch((err) => {
      console.log("err", err);
    });
}

useEffect(() => {
  if (formik.values.clientId) {
    getViewcontract(formik.values.clientId);
  } else {
    setContract([]); 
  }
}, [formik.values.clientId]);


return (
  <div className=" w-full h-full py-2 px-4 ">
       <div className="flex justify-between w-full "> 
       <Breadcrumb
                  items={[
                    // { name: "Testing&Commissioning" },
                    {   name: "Client-Tickets" ,
                      link:"/tickets/client-tickets"
                    },
                    { name: "Edit" },
                  ]}
                />       
      <BackButton />
    </div>
    <form onSubmit={formik.handleSubmit}>
      <div className="w-full mx-auto h-[calc(100vh-145px)] bg-white rounded-xl overflow-hidden mt-4">
      <div className=" w-full h-full flex justify-start content-start flex-wrap py-2 px-4  overflow-y-auto">
          <div className="w-full">
                      <SettingHeading title={`Client Ticket : ${createNew?.refNumber}` } />
            
          </div>
         {GetNotUseRole("client") && (
         
                    <FormikSelectTwo
                                  label="Client"
                                  Options={client}
                                  formik={formik}
                                  placeholder="Choose"
                                  name="clientId"
                                  isRequired={true}
                    
                                  width="w-full md:w-1/3 md:-mt-2"
                                />
                     )}

<FormikSelectTwo
              label="Contract "
              Options={Newcontract}
              formik={formik}
              placeholder="Choose"
              name="contractId"
              isRequired={true}
                         disabled={true}

              width="w-full md:w-1/3 md:-mt-2"
            />

             <NuInput
             type="text"
              label="Subject"
     
              formik={formik}
              placeholder="Choose"
              name="subject"

              width="w-full md:w-1/3 md:-mt-2"
            />

<FormikSelectTwo
              label="Priority"
              Options={Priority}
              formik={formik}
              placeholder="Choose"
              name="priority"

              width="w-full md:w-1/3 "
              displayProperty={"Priority"}
              propertyName={"priority"}
              getFunc={refPriority}

            /> 

<FormikSelectTwo
              label="Ticket Type"
              Options={TicketType}
              formik={formik}
              placeholder="Choose"
              name="ticketType"

              width="w-full md:w-1/3 "
              displayProperty={"Ticket Type"}
              propertyName={"Ticket_Type"}
              getFunc={refTicketType}

            /> 
           <DropDownAddMetaData
              label="Status"
              Options={Status}
              formik={formik}
              placeholder="Choose"
              name="status"

              width="w-full md:w-1/3 md:-mt-1"
              displayProperty={"Status"}
              propertyName={"Status_Support_Tickets"}
              getFunc={refStatus}

            /> 

             <NuTextArea
                          type="text"
                          label="Message"
                          placeholder="Message"
                          formik={formik}
                          name="message"
                          width="w-full md:w-1/2 "
                        />


                        <div className="w-full">
                                                                   <SettingHeading title="Attachments"  />
                                          
                                          <Attachement 
                                              handleChange={handleImageChange}
                                              preview={image || ""}
                                              width="w-full md:w-1/2"
                                              label="Attach"
                                              multiple={true}
                                        removeImages={removeImages}
                        
                                            />
                                        </div>
                                        <div className="md:flex justify-between mt-5 px-3 w-full">
                                          <div className="w-full flex gap-2 items-center flex-wrap">
                                            {data?.attachments &&
                                              filePathList?.map((imgs, idx) => {
                                                console.log("img", imgs);
                                                let Ext = imgs?.file_name.split(".").reverse()[0];
                                                return (
                                                  <div
                                                    className=" w-20 h-9 my-2 relative flex justify-center items-center rounded-lg"
                                                    key={idx}
                                                    style={{
                                                      border: "1px solid gray",
                                                      borderColor:
                                                        "rgb(148 163 184 / var(--tw-bg-opacity))",
                                                    }}
                                                  >
                                                    <div
                                                      className=" w-4 h-4 rounded bg-slate-400 absolute text-white cursor-pointer font-medium flex justify-center items-center  -top-2 -right-2 z-10"
                                                      onClick={() => UpdateAttachmentList(imgs?.file)}
                                                    >
                                                      <CloseIcon color="white" height="8" width="8" />
                                                    </div>
                                                    <div
                                                      className=" w-20 h-9 flex justify-center items-center rounded-lg overflow-hidden cursor-pointer"
                                                      onClick={() => handleImageClick(imgs)}
                                                    >
                                                      <div className=" w-8 h-8">
                                                        {videotype.includes(Ext) ? <Video /> : null}
                          
                                                        {Ext === ("docx" || "doc" || "txt") ? (
                                                          <Doc />
                                                        ) : Ext === ("xlsx" || "xls") ? (
                                                          <Xls />
                                                        ) : Ext === "txt" ? (
                                                          <Txt />
                                                        ) : Ext === "pdf" ? (
                                                          <Pdf />
                                                        ) : Ext === "PDF" ? (
                                                          <Pdf />
                                                        ) : Ext === "pptx" ? (
                                                          <>No file</>
                                                        ) : (
                                                          <img src={imgs?.file} alt="#" width="120%" />
                                                        )}
                                                      </div>
                                                      <p className=" w-[50px] text-[11px] truncate">
                                                        {imgs?.file_name}
                                                      </p>
                                                    </div>
                                                  </div>
                                                );
                                              })}
                          
                                          
                                          </div>
                                        </div>


         
         
          <div className="w-full  my-4 mt-8 ">
            <div className=" flex justify-end gap-4">
              <CancelButton
                handleClick={() => {
                  navigate(-1);
                }}
              />
              <SubmitButton isLoading={isLoading}/>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
);
}

export default EditClientTickets
